<template>
  <v-dialog v-model="dialog" width="800px">
    <v-card>
      <v-card-title class="mx-3">
        {{ $t("CRUD.chooseInfo", [$t("Material.ObjectName")]) }}
        <v-spacer />
        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on" @click="dialog = false">
              fa-times
            </v-icon>
          </template>
          <span>{{ $t("$vuetify.close") }}</span>
        </v-tooltip>
      </v-card-title>
      <v-row dense class="mx-5">
        <v-col cols="12" sm="7">
          <v-row dense align="center" class="pa-1">
            <!-- 关键字即时筛选已加载的全量商品,无需回车/点击查询 -->
            <v-text-field
              v-model="filter"
              clearable
              :label="$t('MaterialTemplate.priceTypes.filterHint')"
              append-icon="fa-search"
            ></v-text-field>
          </v-row>
        </v-col>
        <v-col cols="12" sm="5" align-self="center">
          <v-row dense align="center" class="pa-1">
            <!-- 手动刷新：丢弃本地缓存重新从接口拉取全部商品 -->
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  v-bind="attrs"
                  v-on="on"
                  x-small
                  color="primary"
                  class="me-1"
                  style="cursor: pointer"
                  @click.stop="refresh()"
                >
                  fa-sync
                </v-icon>
              </template>
              <span>{{ $t("Order.actions.refreshMaterials") }}</span>
            </v-tooltip>
            <span class="caption secondary--text">
              {{ $t("Order.actions.selectAllTemplateMaterialsHint") }}
            </span>
          </v-row>
        </v-col>
      </v-row>
      <v-data-table
        :headers="headers"
        :items="templateDetails"
        :loading="loading"
        item-key="_rowId"
        multi-sort
        class="elevation-0 px-6"
        v-resize="resizeHeader"
        :no-data-text="noDataText"
        :footer-props="footerProps"
      >
        <template v-slot:header.choose>
          <v-checkbox
            class="mt-2 mb-n3"
            color="primary"
            :indeterminate="mixedChoose"
            v-model="chooseAll"
            :true-value="1"
            :false-value="0"
          >
            <template v-slot:label>
              <span class="caption ms-n2">
                {{ $t("CRUD.chooseAll") }}
              </span>
            </template>
          </v-checkbox>
        </template>

        <template v-slot:item.choose="{ item }">
          <div class="d-flex mt-n2 mb-n3">
            <v-checkbox
              color="primary"
              v-model="item.choose"
              :true-value="1"
              :false-value="0"
              :disabled="item.disabled"
            >
              <template v-slot:label>
                <span class="caption ms-n2">
                  {{ $t(item.choose ? "CRUD.choosed" : "CRUD.unchoose") }}
                </span>
              </template>
            </v-checkbox>
          </div>
        </template>

        <template v-slot:item.Description="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <span v-bind="attrs" v-on="on">
                <v-icon x-small>{{ item.combineFlg ? "fa-box" : item.hide_flg ? "fa-eye-slash" : "fa-eye" }}</v-icon>
                {{ item.displayName }}
              </span>
            </template>
            <span>{{ item.Description }}</span>
          </v-tooltip>
          <br />
          <span
            v-if="item.subText"
            class="caption secondary--text"
            :title="item.subText"
            style="cursor: pointer"
          >
            {{ $t("Material.Fields.standard") }}{{ $t("Global.colon")
            }}{{ item.subText.length > 20 ? item.subText.slice(0, 20) + "......" : item.subText }}
          </span>
        </template>
        <template v-slot:item.priceText="{ item }">
          <span class="text-no-wrap">
            {{ $t("Global.money") }}{{ item.priceText }}
          </span>
        </template>
      </v-data-table>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          outlined
          @click="dialog = false"
          class="elevation-1"
        >
          {{ $t("$vuetify.close") }}
        </v-btn>
        <v-btn
          color="accent"
          :disabled="!choosenCount"
          @click="confirm()"
        >
          {{ $t("CRUD.confirmWithChooseCount", [choosenCount]) }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>


<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import MaterialTemplates from "@/api/material_templates";

export default {
  name: "SelectAllTemplateMaterials",

  props: {
    value: Boolean,
    shopId: Number,
    // 已在订单明细中的条目：{combineFlg: true, ruler_id} | {material_id}
    disabledItems: Array,
  },

  computed: {
    headers() {
      return [
        {
          text: i18n.t("MaterialTemplate.Fields.material_category"),
          align: "start",
          sortable: true,
          filterable: true,
          value: "categoryText",
        },
        {
          text: i18n.t("MaterialTemplate.Fields.material"),
          align: "start",
          sortable: true,
          filterable: true,
          value: "Description",
        },
        {
          text: i18n.t("MaterialTemplate.Fields.supply_price"),
          align: "end",
          sortable: false,
          filterable: false,
          value: "priceText",
        },
        {
          // 勾选框列固定在表格末尾
          text: "",
          align: "center",
          sortable: false,
          filterable: false,
          value: "choose",
        },
      ];
    },
    footerProps() {
      return Object.assign({}, i18n.t("$config.footer-props"), {
        itemsPerPageOptions: [this.itemsPerPageOptions],
      });
    },
    // 全部可选行（组合商品 + 模板商品），关键字输入时前端即时过滤
    templateDetails() {
      var items = this.combineMaterials.concat(this.materials);
      if (!this.filter) return items;
      var keyword = this.filter.toLowerCase();
      return items.filter(
        (item) =>
          item.Description && item.Description.toLowerCase().indexOf(keyword) >= 0
      );
    },
    choosedRows() {
      return this.materials
        .concat(this.combineMaterials)
        .filter((d) => d.choose == 1 && !d.disabled);
    },
    choosenCount() {
      return this.choosedRows.length;
    },
    mixedChoose() {
      return this.materials
        .concat(this.combineMaterials)
        .some((d) => !d.disabled && d.choose != this.chooseAll);
    },
    noDataText() {
      if (this.loading) return i18n.t("MaterialTemplate.loadingText");
      return i18n.t("$vuetify.noDataText");
    },
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["settings"]),
  },

  data: () => ({
    dialog: false,
    itemsPerPageOptions: 10,
    filter: "", // 关键字（前端即时过滤）
    loading: false,
    materials: [], // 门店模板商品（fetchByShop 返回的 template_details）
    combineMaterials: [], // 门店组合商品（fetchCombineMaterialsByShop 返回的 combine_materials）
    chooseAll: 0,
  }),

  methods: {
    resizeHeader() {
      this.itemsPerPageOptions = window.innerHeight > 800 ? 10 : 5;
    },
    confirm() {
      this.$emit("confirm", this.choosedRows);
      this.dialog = false;
    },
    // 组合商品数量少，先一次全量获取后常驻，随后链式加载全部模板商品
    getCombineMaterialsFromAPI() {
      this.loading = true;
      MaterialTemplates.fetchCombineMaterialsByShop(this.shopId)
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              this.combineMaterials = (response.data.combine_materials
                ? response.data.combine_materials
                : []
              ).map((item) => this.makeCombineRow(item));
            } else {
              this.combineMaterials = [];
            }
            this.getTemplateMaterialsFromAPI();
          }.bind(this),
          function () {
            this.combineMaterials = [];
            this.getTemplateMaterialsFromAPI();
          }.bind(this)
        );
    },
    getTemplateMaterialsFromAPI() {
      this.loading = true;
      // 不传关键字一次拉取全量，过滤与分页均在前端完成
      MaterialTemplates.fetchByShop(this.shopId, {
        keyword: "",
      })
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              this.materials = (response.data.template_details
                ? response.data.template_details
                : []
              ).map((item, index) => this.makeMaterialRow(item, index));
            } else {
              this.materials = [];
            }
            this.loading = false;
          }.bind(this),
          function () {
            this.materials = [];
            this.loading = false;
          }.bind(this)
        );
    },
    isDisabled(combineFlg, id) {
      if (!this.disabledItems) return false;
      return !!this.disabledItems.find((disabledItem) =>
        combineFlg
          ? disabledItem.combineFlg &&
            disabledItem.ruler_id == id
          : !disabledItem.combineFlg && disabledItem.material_id == id
      );
    },
    // 手动刷新：丢弃本地缓存重新从接口拉取全部商品
    refresh() {
      if (!this.shopId || this.loading) return;
      this.filter = "";
      this.chooseAll = 0;
      this.materials = [];
      this.combineMaterials = [];
      this.getCombineMaterialsFromAPI();
    },
    // 弹窗重开时明细可能已变化，按最新明细同步缓存行的禁用/勾选状态
    refreshDisabledStates() {
      this.materials.forEach((item) => this.syncRowDisabled(item, false));
      this.combineMaterials.forEach((item) => this.syncRowDisabled(item, true));
    },
    syncRowDisabled(item, combineFlg) {
      var disabled = this.isDisabled(
        combineFlg,
        combineFlg ? item.id : item.material_id
      );
      if (disabled) {
        item.disabled = true;
        item.choose = 1; // 已加入明细的行以禁用占位呈现
      } else if (item.disabled) {
        item.disabled = false;
        item.choose = 0; // 该商品从明细移除后恢复可勾选
      }
    },
    makeMaterialRow(item, index) {
      var disabled = this.isDisabled(false, item.material_id);
      var displayType = this.settings
        ? this.settings.material_name_display_type
        : 0;
      return Object.assign({}, item, {
        _rowId: "m" + index,
        combineFlg: false,
        choose: disabled ? 1 : 0,
        disabled: disabled,
        categoryText: item.category_name ? item.category_name : "",
        displayName: i18n.t(
          displayType == 1
            ? "Material.materialName"
            : displayType == 4
            ? "Material.nameWithCode"
            : "Material.materialNameWithCode",
          [item.material_code, item.material_name]
        ),
        // 名称+规格+条码拼接文本，供搜索与悬停查看完整信息
        Description: i18n.t(
          displayType == 4
            ? "Material.nameWithCodeAndStandard"
            : displayType == 3
            ? "Material.materialNameWithCodeAndStandard"
            : displayType == 2
            ? "Material.materialNameWithCode"
            : "Material.materialName",
          [item.material_code, item.material_name, item.standard_name]
        ) + (item.barcode ? "(" + item.barcode + ")" : ""),
        subText: item.standard_name ? item.standard_name : "",
        priceText: this.makePriceText(
          item.count_unit &&
            item.count_unit_rate &&
            this.settings &&
            this.settings.count_unit == 1
            ? Number(item.supply_price) * Number(item.count_unit_rate)
            : item.supply_price,
          item.unit
        ),
      });
    },
    makeCombineRow(item) {
      var disabled = this.isDisabled(true, item.id);
      var detailsText = item.details
        ? item.details
            .map((detail) => detail.material_name + "x" + detail.combine_num)
            .join(", ")
        : "";
      return Object.assign({}, item, {
        _rowId: "c" + item.id,
        combineFlg: true,
        choose: disabled ? 1 : 0,
        disabled: disabled,
        categoryText: i18n.t("Material.Fields.combine_material"),
        displayName: item.material_name ? item.material_name : item.name,
        Description:
          (item.material_name ? item.material_name : item.name) +
          (detailsText ? "(" + detailsText + ")" : ""),
        subText: detailsText,
        priceText: this.makePriceText(item.price),
      });
    },
    makePriceText(price, unit) {
      return (
        this.$numberFormatter.formatMoney(price ? price : 0) +
        (unit ? " / " + unit : "")
      );
    },
  },

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        this.dialog = this.value;
        if (this.dialog) {
          // 缓存策略：首次打开自动加载全部商品；关闭再打开不再请求接口,
          // 仅按最新明细同步禁用状态，筛选关键字与勾选结果一并保留
          if (
            this.shopId &&
            !this.materials.length &&
            !this.combineMaterials.length
          ) {
            if (!this.loading) this.getCombineMaterialsFromAPI();
          } else {
            this.refreshDisabledStates();
          }
        }
      },
    },
    shopId() {
      // 切换门店后旧门店缓存失效，清空等待重新加载
      this.filter = "";
      this.chooseAll = 0;
      this.materials = [];
      this.combineMaterials = [];
    },
    filter() {
      // 保持全选状态：新的筛选结果自动纳入全选范围
      if (this.chooseAll == 1) {
        this.templateDetails.forEach(function (detail) {
          if (!detail.disabled) detail.choose = 1;
        });
      }
    },
    dialog: {
      handler() {
        this.$emit("input", this.dialog);
      },
    },
    chooseAll: {
      handler() {
        // 只需遍历当前筛选结果行（disabled的已存在商品不参与全选）
        var valid = this.chooseAll ? 1 : 0;
        this.templateDetails.forEach(function (detail) {
          if (!detail.disabled) detail.choose = valid;
        });
      },
    },
  },
};
</script>
